import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { Typography, makeStyles, withStyles } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Skeleton } from "@material-ui/lab";
import { useSelector, useDispatch } from "react-redux";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { announcementApiLoading } from "../../../model/action";

const useStyles = makeStyles((theme) => ({
  errroIcon: {
    width: "10em",
    height: "auto",
    margin: "2em auto",
    display: "block",
    color: theme.palette.eLight.base,
  },
  mobileHeading: {
    color: theme.palette.ePrimary.base,
    textAlign: "center",
    paddingTop: '0.6rem'
  },
  colorPrimary: {
    color: theme.palette.ePrimary.base,
  },
  errorText: {
    textAlign: "center",
  },
  viewAll: {
    textAlign: "center",
    color: theme.palette.ePrimary.base,
    cursor: "pointer",
  },
  announcementTitle: {
    fontSize: "0.875rem",
    fontWeight: "500",
  },
  announcementGrid: {
    [theme.breakpoints.up("xs")]: {
      marginTop: "5%",
      marginLeft: "5%",
      width: "90%",
    },
    [theme.breakpoints.up("md")]: {
      marginTop: "2%",
      marginLeft: "2.5%",
      width: "95%",
    },
    "&:last-child": {
      marginBottom: "5%",
    },
  },
  announcementContainer: {

  },
}));

const AccordionSummary = withStyles((theme) => ({
  root: {
    borderBottom: "1px solid " + theme.palette.eLight.base,
    minHeight: "auto",
    "&$expanded": {
      minHeight: 40,
    },
  },
  content: {
    margin: "0% 0%",
    width: "80%",
    "&$expanded": {
      margin: "0% 0%",
    },
  },
  expanded: {
    height: "auto",
  },
}))(MuiAccordionSummary);

  
function EAnnouncements({ getAnnouncementsData, searchAnnData, keyWord }) {
  const dispatch= useDispatch();
  const classes = useStyles();
  const ANNOUNCEMENT_LIMIT = 6;
  const {t:labels, ready: labelReady} = useTranslation("label-E_AUTH_LOGIN");
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 550px)" });
  const [announcements, setAnnouncements] = useState([]);
  const [initialAnnouncements, setInitialAnnouncements] = useState([]);
  const [allAnnouncements, setAllAnnouncements] = useState([]);

  const [viewAllToggle, setViewAllToggle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const languageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const dateFormat = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.SHORT_DATE_FORMAT
  );
  const browserName = useSelector((store) => store?.browserDetect?.browserName);
  useEffect(() => {
    if (keyWord === undefined) {
      if (languageCode) {
        dispatch(announcementApiLoading(true))
        setLoading(false);
        getAnnouncementsData(languageCode)
          .then((res) => {
            setInitialAnnouncements(res.slice(0, ANNOUNCEMENT_LIMIT));
            setAllAnnouncements([...res]);
            setAnnouncements(res.slice(0, ANNOUNCEMENT_LIMIT));
            setLoading(false);
            dispatch(announcementApiLoading(false))
          })
          .catch((err) => {
            setLoading(false);
            setIsError(true);
            dispatch(announcementApiLoading(false))
          });
      } }else {
        if (searchAnnData) {
          setInitialAnnouncements(searchAnnData?.slice(0, ANNOUNCEMENT_LIMIT));
          setAllAnnouncements(searchAnnData);
          setAnnouncements(searchAnnData.slice(0, ANNOUNCEMENT_LIMIT));
        }
    }
  }, [languageCode, keyWord, searchAnnData]);
  useEffect(() => {
    if (viewAllToggle) setAnnouncements(allAnnouncements);
    else setAnnouncements(initialAnnouncements);
  }, [viewAllToggle,allAnnouncements,initialAnnouncements]);
  return (
    <>
      {loading && (
        <>
          <Skeleton variant="text"></Skeleton>
          <Skeleton variant="text"></Skeleton>
          <Skeleton variant="text"></Skeleton>
          <Skeleton variant="text"></Skeleton>
        </>
      )}
      {isError && (
        <>
          <ReportProblemOutlinedIcon className={classes.errroIcon} />
          {
            labelReady ?
          <Typography className={classes.errorText}>
            {labels("E_ERROR_MESSAGE")}
          </Typography>
          : <Skeleton />
          }
        </>
      )}
      {(announcements.length && !isError) || !loading ? (
        <>
          {isTabletOrMobile && (
            <Typography
              variant="h3"
              class={classes.mobileHeading}
              align="center"
            >
              {labelReady ? labels("E_ANNOUNCEMENT_MOBILE_HEADING") : <Skeleton />}
            </Typography>
          )}
          <div
            className={classes.announcementContainer}
            style={{
              overflowY:
                viewAllToggle || expanded !== null
                  ? browserName === "firefox"
                    ? "auto"
                    : "overlay"
                  : "hidden",
            }}
          >
            {announcements.map((announcement, key) => {
              return (
                <div className={classes.announcementGrid} item xs={12}>
                  <Accordion
                    expanded={key == expanded}
                    onClick={(e) => {
                      if (expanded == key) setExpanded(null);
                      else setExpanded(key);
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography
                        className={classes.announcementTitle}
                        variant="subtitle2"
                        noWrap={expanded != key}
                      >
                       {announcement.StartDate?moment(announcement.StartDate).format(dateFormat):moment(announcement?._source?.ContentStartDate).format('ll')}
                        &nbsp;-&nbsp;{announcement?.AnnouncementTitle? announcement?.AnnouncementTitle : announcement?._source?.ContentTitle}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        variant="subtitle2"
                        dangerouslySetInnerHTML={{
                          __html: announcement?.AnnouncementDescription ? announcement?.AnnouncementDescription:announcement?._source?.ContentValue,
                        }}
                      />
                    </AccordionDetails>
                  </Accordion>
                </div>
              );
            })}
          </div>
          {allAnnouncements.length > ANNOUNCEMENT_LIMIT && labelReady ? (
            <Typography
              variant="subtitle2"
              className={[classes.viewAll, classes.colorPrimary].join(" ")}
              onClick={(e) => {
                setViewAllToggle(!viewAllToggle);
              }}
            >
              {!viewAllToggle ? labels("E_VIEW_ALL") : labels("E_VIEW_LESS")}
            </Typography>
          ) : null}
        </>
      ) : !loading && (
        <>
          <ReportProblemOutlinedIcon className={classes.errroIcon} />
          <Typography className={classes.errorText}>
          {
            labelReady ?
            labels("E_NO_RECORDS_FOUND_MESSAGE")
            : <Skeleton />
          }
          </Typography>
        </>
      )}
    </>
  );
}

export default EAnnouncements;
